import type { LegalPageKind, LegalSlugData } from '@features/legal/types'

export const LEGAL_SLUG_DATA: Record<
  LegalPageKind,
  Record<string, LegalSlugData>
> = {
  confidential: {
    kg: {
      city: 'bishkek',
      title: 'Политика конфиденциальности — Ресторан Farfor в Кыргызстане',
      description:
        'Администрация обязуется использовать персональные данные, полученные в результате использования Сайта в соответствии с требованиями законодательства Кыргызской Республики «Об информации персонального характера» от 14.04.2008 года, за № 58 и постановления Правительства Кыргызской Республики «Об утверждении Требований к обеспечению безопасности и защите персональных данных при их обработке в информационных системах персональных данных, исполнение которых обеспечивает установленные уровни защищенности персональных данных» от 21.11.2017 года за №. 76.',
    },
    com: {
      city: 'uralsk',
      title: 'Политика конфиденциальности — Ресторан Farfor в Казахстане',
      description:
        'Администрация обязуется использовать персональные данные, полученные в результате использования Сайта в соответствии с требованиями законодательства о защите персональных данных, соответствии приказа ,подпунктом 7) пункта 1 статьи 27-1 Закона Республики Казахстан от 21 мая 2013 года "О персональных данных и их защите".',
    },
    ru: {
      city: 'ufa',
      title: 'Политика конфиденциальности — Ресторан Farfor в России',
      description:
        'Настоящая политика Конфиденциальности приложений и сайтов ресторана доставки «Фарфор» действует в отношении всей информации, которую ООО Ресторан «Фарфор» может получить о пользователе во время использования им приложений и сайтов ООО «Фарфор Франчайзинг» и его партнеров.',
    },
  },
  terms_of_use: {
    kg: {
      city: 'bishkek',
      title: 'Пользовательское соглашение — Ресторан Farfor в Кыргызстане',
      description:
        'Персональные данные получаются в связи с заключением договора, стороной которого является субъект персональных данных. Персональные данные не распространяются, а также не предоставляются третьим лицам без согласия субъекта персональных данных и используются оператором исключительно для исполнения указанного соглашения и заключения договоров с субъектом персональных данных.',
    },
    com: {
      city: 'uralsk',
      title: 'Пользовательское соглашение — Ресторан Farfor в Казахстане',
      description:
        'Персональные данные получаются в связи с заключением договора, стороной которого является субъект персональных данных. Персональные данные не распространяются, а также не предоставляются третьим лицам без согласия субъекта персональных данных и используются оператором исключительно для исполнения указанного соглашения и заключения договоров с субъектом персональных данных.',
    },
    ru: {
      city: 'ufa',
      title: 'Пользовательское соглашение — Ресторан Farfor в России',
      description:
        'Персональные данные получаются в связи с заключением договора, стороной которого является субъект персональных данных. Персональные данные не распространяются, а также не предоставляются третьим лицам без согласия субъекта персональных данных и используются оператором исключительно для исполнения указанного соглашения и заключения договоров с субъектом персональных данных.',
    },
  },
}

export const DEFAULT_LEGAL_SLUG_DATA: Record<LegalPageKind, LegalSlugData> = {
  confidential: {
    city: 'ufa',
    title: 'Политика конфиденциальности — Ресторан Farfor в России',
    description:
      'Настоящая политика Конфиденциальности приложений и сайтов ресторана доставки «Фарфор» действует в отношении всей информации, которую ООО Ресторан «Фарфор» может получить о пользователе во время использования им приложений и сайтов ООО «Фарфор Франчайзинг» и его партнеров.',
  },
  terms_of_use: {
    city: 'ufa',
    title: 'Пользовательское соглашение — Ресторан Farfor в России',
    description:
      'Персональные данные получаются в связи с заключением договора, стороной которого является субъект персональных данных. Персональные данные не распространяются, а также не предоставляются третьим лицам без согласия субъекта персональных данных и используются оператором исключительно для исполнения указанного соглашения и заключения договоров с субъектом персональных данных.',
  },
}

export const LEGAL_PAGE_META: Record<
  LegalPageKind,
  { path: string; breadcrumbText: string; breadcrumbHref: string }
> = {
  confidential: {
    path: '/confidential/',
    breadcrumbText: 'Политика конфиденциальности',
    breadcrumbHref: '/confidential/',
  },
  terms_of_use: {
    path: '/terms_of_use/',
    breadcrumbText: 'Пользовательское соглашение',
    breadcrumbHref: '/terms_of_use/',
  },
}
